<app-steps [step]='2'></app-steps>

<div class="row" *ngIf="giftVoucher!=null">
    <div class="col-sm-5 col-md-5">
        <img onerror="this.src='assets/images/gv-image.png'" src="assets/images/{{giftVoucher.imageUrl}}" class="img-fluid"
            alt="{{giftVoucher.imageUrl}}">
    </div>
    <div class="col-sm-7 col-md-7">
        <div style="padding:10px" >
            <br class="d-block d-sm-none">
            
            <div class="row">
                <div class="col">
                    <h3 class="card-title main-title">
                        {{giftVoucher.name}}<br>
                        <small class="price"><span [innerHTML]="app.config.currencySymbol"></span>{{giftVoucher.fee | number : '1.2-2'}}</small>
                    </h3>
                </div>
            </div>
            <!-- <h2 class="main-title">{{giftVoucher.name}}</h2>
            <h4 class="price"><span [innerHTML]="app.config.currencySymbol"></span>{{giftVoucher.fee | number : '1.2-2'}}</h4> -->
            <p class="card-text itemDescription" [innerHTML]="giftVoucher.description"></p>
            <div class="row" *ngIf="app.config.showForMe">
                <div class="col-sm-6">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text no-border">
                                <input type="checkbox" (change)="updateScreen(true)"
                                    [className]="isForMyself ? 'checkbox' : ''" [(ngModel)]="isForMyself"
                                    [ngModelOptions]="{standalone: true}">
                            </div>
                        </div>
                        <input type="text" readonly class="form-control-plaintext" value="This is for Me">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text no-border">
                                <input type="checkbox" [className]="isForOthers ? 'checkbox' : ''"
                                    [(ngModel)]="isForOthers" (change)="updateScreen()"
                                    [ngModelOptions]="{standalone: true}">
                            </div>
                        </div>
                        <input type="text" readonly class="form-control-plaintext" value="This is a gift">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <a class="btn btn-blue" (click)="addToBasket(template)">Add to Basket</a>
                    <a class="btn btn-blue" (click)="checkout()">Checkout</a>
                    <!-- <a class="btn btn-primary" (click)="back()">Back to Voucher Page</a> -->
                </div>
            </div>

        </div>
    </div>
</div>

<ng-template #template>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Gift Voucher Beneficiary</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label for="beneficiaryName">First Name</label>
            <input type="beneficiaryName" class="form-control" id="beneficiaryName" placeholder="First Name"
                [(ngModel)]="beneficiary.firstName">
        </div>
        <div class="form-group">
            <label for="beneficiaryName">Last Name</label>
            <input type="beneficiaryName" class="form-control" id="beneficiaryName" placeholder="Last Name"
                [(ngModel)]="beneficiary.lastName">
        </div>
        <div class="form-group">
            <label for="beneficiaryMessage">Message</label>
            <textarea type="beneficiaryMessage" maxlength="200" [(ngModel)]="beneficiary.message" class="form-control"
                id="beneficiaryMessage" placeholder="Message"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <a class="btn btn-blue" (click)="cancel()">Close</a>
        <a class="btn btn-blue" (click)="continue()">Continue</a>
    </div>
</ng-template>